import Ajax from '../../../../util/ajax';
export function zigbeeNwkAddr(zigbee_node_id) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/zigbee/' + zigbee_node_id + '/nwk';
        ajax.post(url);
    };
}
